function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled } from 'styled-components';
const StyledAnchor = styled.a.withConfig({
  componentId: "aui__sc-z9bgpq-0"
})(["color:inherit;text-decoration:underline;&:hover{text-decoration:none;}"]);

// comment to kickstart release

export const Inline = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(StyledAnchor, _extends({
  "data-aui": "action.inline"
}, props), children);